module.exports = __webpack_public_path__ + "static/img/vip_activate.7cb7172.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/vip_activate.png
// module id = PMEf
// module chunks = 37